import React from "react";
import Layout from "../Layout/Layout";

const Register = () => {
  return (
    <Layout>
      <h2>this is register</h2>
    </Layout>
  );
};

export default Register;
